<template>
    <section class="it-hero-wrapper">
        <div class="container-fluid">
            <div class="container">
                <BreadcrumbNode class="d-block d-lg-none" :article="null" :section="null" background="dark"/>
                <div class="row">
                    <div class="col-12">
                        <div class="it-hero-text-wrapper bg-dark pt-0 pe-0">
                            <h1 class="hero-title mt-5">Politica di utilizzo</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="container mt-4 mb-5">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <div class="politica-content">
                    <h2 class="h4 fw-bold mb-4">Politica di utilizzo del Chatbot AI4RUP</h2>

                    <p>AI4RUP è un'assistente digitale messo a disposizione dal Ministero delle Infrastrutture e dei Trasporti ("<strong>MIT</strong>") basato su un sistema di intelligenza artificiale generativa. Il servizio genera automaticamente le risposte a partire dalle informazioni disponibili e dalle funzionalità programmate, in nessun caso è previsto il contatto o il dialogo con un operatore umano.</p>

                    <p>Il servizio è progettato per supportare gli utenti esclusivamente nella consultazione e nell'accesso semplificato alle informazioni del mondo dei contratti pubblici. In particolare, il sistema mira ad agevolare e velocizzare le attività quotidiane dei Responsabili Unici del Progetto (RUP), che rappresentano i principali destinatari del servizio.</p>

                    <p>In qualità di utente di AI4RUP, sei tenuto a utilizzare il servizio in modo conforme alla presente politica di utilizzo e alle finalità per cui è stato reso disponibile.</p>

                    <p>Ricorda che AI4RUP parla italiano ed elabora richieste poste in italiano, per cui ti invitiamo a non usare altre lingue.</p>

                    <p>Ti ricordiamo inoltre di:</p>
                    <ul>
                        <li class="mb-2"><strong>inserire dati personali solo ove strettamente necessario</strong>; in ogni caso, eventuali dati personali, tuoi o di terzi, e le informazioni che condividi su di te verranno usati solo per fornire la risposta e gestiti secondo quanto previsto nell'<RouterLink to="/informativa-privacy">informativa privacy</RouterLink>;</li>
                        <li class="mb-2"><strong>usare un linguaggio appropriato</strong>, evitare volgarità o offese;</li>
                        <li class="mb-2"><strong>non porre domande ad oggetto diverso</strong> dal Codice dei contratti pubblici (d.lgs 36/2023), altrimenti AI4RUP non saprà rispondere alle tue domande;</li>
                        <li class="mb-2"><strong>controllare sempre la correttezza delle risposte</strong>, queste hanno finalità informativa e servono ad agevolare la consultazione e l'applicazione del Codice dei contratti pubblici, non sostituiscono pareri legali né altra consulenza professionale. Inoltre, trattandosi di un sistema di IA generativa, AI4RUP può anche fornire risposte verosimili ma non corrette (c.d. allucinazioni), pertanto è necessario verificare sempre l'esattezza e l'aggiornamento delle informazioni facendo riferimento alle fonti ufficiali che troverai richiamate nella risposta. Se un responso risulta non appropriato o contiene errori, ti chiediamo di segnalarcelo tramite lo strumento di <em>feedback</em>;</li>
                        <li class="mb-2">tenere presente che <strong>le tue conversazioni saranno conservate</strong> per un periodo massimo di 30 giorni dalla chiusura della sessione, salvo necessità di ulteriore conservazione in caso di incidenti, reclami, tue richieste, per scopi di monitoraggio e miglioramento applicativo o obblighi di legge. In ogni caso, le conversazioni non saranno utilizzate per migliorare il servizio o per addestrare il modello di IA.</li>
                    </ul>

                    <p class="mt-4">Accedendo al servizio, quindi, dichiari di essere consapevole ed accettare che:</p>
                    <ul>
                        <li class="mb-2">l'interazione con AI4RUP è funzionale ad acquisire informazioni sul Codice dei contratti pubblici (d.lgs 36/2023), quindi, se lo interroghi su altri temi, non saprà risponderti;</li>
                        <li class="mb-2">l'output fornito da AI4RUP potrebbe non essere corretto e, pertanto, che le informazioni fornite devono essere sempre verificate e, in ogni caso, esse non costituiscono né sostituiscono il parere professionale di un esperto;</li>
                        <li class="mb-2">i tuoi dati personali saranno trattati come da <RouterLink to="/informativa-privacy">informativa privacy</RouterLink>, ma evita di fornire informazioni personali non necessarie; se inserisci dati di terzi, garantisci sotto la tua responsabilità la relativa utilizzabilità;</li>
                        <li class="mb-2">AI4RUP non deve essere utilizzato per acquisire informazioni o per scopi diversi da quelli autorizzati, né per sperimentazioni improprie o contrarie alla legge. In particolare è vietato:
                            <ol class="mt-2">
                                <li class="mb-1">(i) formulare richieste volte a manipolare, aggirare o eludere regole, limitazioni o controlli del sistema o dei servizi collegati (es. <em>prompt injection</em>, tentativi di ottenere istruzioni o contenuti vietati, richieste di informazioni sul funzionamento interno, esfiltrazione di configurazioni, log, chiavi o credenziali);</li>
                                <li class="mb-1">(ii) inserire, richiedere, ricostruire o inferire dati personali di terzi senza idonea base giuridica;</li>
                                <li class="mb-1">(iii) richiedere o divulgare informazioni riservate o coperte da segreto (es. credenziali e dati di accesso, documenti interni non pubblici, informazioni soggette ad accordi di riservatezza, segreti commerciali o professionali);</li>
                                <li class="mb-1">(iv) utilizzare linguaggio offensivo, discriminatorio, minaccioso o comunque sconveniente, o generare/diffondere contenuti illeciti, diffamatori o ingannevoli;</li>
                                <li class="mb-1">(v) svolgere attività che possano compromettere la sicurezza o l'operatività del servizio (es. caricamento/inserimento di codice o istruzioni malevole, test di vulnerabilità non autorizzati o spam);</li>
                                <li class="mb-1">(vi) violare diritti di proprietà intellettuale (es. diritto d'autore, marchi, brevetti, licenze), anche mediante caricamento o richiesta di contenuti protetti (testi, immagini, codice, documenti) senza titolo, autorizzazione o oltre i limiti consentiti, nonché tramite aggiramento di misure di protezione.</li>
                            </ol>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <ChatBot />
</template>

<script>
import BreadcrumbNode from '../navigator/BreadcrumbNode.vue';
import ChatBot from '../partials/ChatBot.vue';

export default {
    name: "PoliticaView",
    components: {
        BreadcrumbNode,
        ChatBot
    },
    mounted() {
        this.$root.loadBreadcrumb(null);
    }
}
</script>

<style scoped>
.politica-content p,
.politica-content li {
    line-height: 1.7;
}

.politica-content ul,
.politica-content ol {
    padding-left: 1.5rem;
}

.politica-content ul li,
.politica-content ol li {
    margin-bottom: 0.4rem;
}
</style>
